export default function skipToContent(): void {
    const trigger = document.querySelector('.sgw-skip-link') as HTMLElement | null;
    if (!trigger) {
        return;
    }

    trigger.addEventListener('click', (e: MouseEvent) => {
        e.preventDefault();
        const target = e.currentTarget as HTMLAnchorElement;
        const id = target.getAttribute('href');
        if (!id) return;

        const mainContent = document.querySelector(id) as HTMLElement | null;
        if (!mainContent) return;
        mainContent.focus();
    });
}
